<template>
  <div class="slogan">
    <Header :absolute="true"></Header>
    <div class="swipper">
      <transition name="fade">
        <div class="swipper-item swipper-item1" v-if="currentIndex == 0">
          <div class="title">
            通信新时代
          </div>
          <div class="items">
            <div class="item">New era of communication</div>
          </div>

          <div class="download">
            <div class="downitem" @click="downaos">
              <img class="downimg" src="./imgs/downaos.png" />
              <div class="downtxt">
                Android
              </div>
            </div>
            <div class="downitem" @click="downios">
              <img class="downimg" src="./imgs/downios.png" />
              <div class="downtxt">
                iOS
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Header from "../Header";

export default {
  components: {
    Header
  },
  data() {
    return {
      currentIndex: 0
    };
  },
  methods: {
    downaos() {
      // window.open("https://app.2uchat.cn/2U/release/2U-latest.apk");
      window.open("https://app.2uchat.cn/captcha/index.html");
    },
    downios() {
      window.open("https://apps.apple.com/cn/app/%E9%80%9A%E5%8F%8B-%E4%B8%80%E6%AC%BE%E5%BC%80%E6%94%BE%E5%BC%8F%E7%9A%84%E6%99%BA%E8%83%BD%E5%8D%B3%E6%97%B6%E9%80%9A%E8%AE%AF%E8%BD%AF%E4%BB%B6/id6450920571");
    }
  }
};
</script>

<style lang="scss" scoped>
.slogan {
  position: relative;
  height: 5.4rem;
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .swipper {
    position: relative;
    height: 5.4rem;
    .swipper-item {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 5.4rem;
    }
    .swipper-item1 {
      background: linear-gradient(180deg, #62b4d9 0%, #29708e 100%);
      background-size: 100% 100%;
    }
    .title {
      font-size: 0.34rem;
      text-align: left;
      margin-top: 1rem;
      margin-left: 2.3rem;
    }
    .items {
      font-size: 0;
      text-align: left;
      margin-top: 0.3rem;
      margin-left: 2.3rem;
      .item {
        display: inline-block;
        font-size: 0.15rem;
        line-height: 0.15rem;
        vertical-align: middle;
        margin-right: 0.1rem;
        padding-right: 0.1rem;
        border-right: 1px solid #fff;
        &:last-child {
          margin-right: 0;
          border: none;
        }
      }
    }
    .download {
      font-size: 0;
      margin-top: 1rem;
      height: 1rem;
      float: right;
      margin-right: 2rem;
      .downitem {
        display: inline-block;
        width: 0.7rem;
        cursor: pointer;
        height: 0.7rem;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 0.35rem;
        &:last-child {
          margin-left: 0.3rem;
        }
        .downimg {
          margin-top: 0.18rem;
          margin-left: 0.23rem;
        }
        .downtxt {
          font-size: 0.1rem;
          text-align: center;
          width: 100%;
          height: 0.2rem;
        }
      }
    }
  }
}
</style>
